<svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
  <path d="M4.13438 0.75H12.9338M4.13438 4.81125H12.9338M4.13438 8.8725H12.9338M0.75 0.75H0.756769M0.75 4.81125H0.756769M0.75 8.8725H0.756769" stroke="#0D0D0D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
